<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="活动ID" :value="1"></el-option>
                            <el-option label="活动名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制活动状态" value=""></el-option>
                        <el-option label="仅看未开始的" :value="1"></el-option>
                        <el-option label="仅看进行中的" :value="2"></el-option>
                        <el-option label="仅看已结束的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/scene/punch/saveOrUpdate')" type="primary" icon="el-icon-plus" size="small"
                @click="add()">创建活动</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="id" label="活动ID"></el-table-column>
                <el-table-column prop="name" label="活动名称" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column label="活动时间" :min-width="180">
                    <template slot-scope="scope">
                        <p>从：{{ `${scope.row.startTime}` }}</p>
                        <p>到：{{ `${scope.row.endTime}` }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="statusName" label="状态"></el-table-column>
                <el-table-column prop="joinNum" label="参与活动用户数" min-width="110"></el-table-column>
                <el-table-column prop="clearCustomsNum" label="完成全部打卡用户数" min-width="110"></el-table-column>
                <el-table-column fixed="right" label="操作" width="250">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/scene/punch/saveOrUpdate')" type="text" size="small"
                            @click="edit(scope.row.id)">编辑</el-button>
                        <el-button v-if="$utils.have('/scene/punch/detail')" type="text" size="small"
                            @click="$refs.statistics.show(scope.row)">活动数据</el-button>
                        <el-button type="text" size="small" @click="copy(scope.row.wapLink)">活动链接</el-button>
                        <el-button v-if="$utils.have('/scene/punch/downQrCode')" type="text" size="small"
                            @click="download(scope.row.id)">下载二维码</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <Statistics ref="statistics"></Statistics>
        <input class="copyTool" ref="copyTool" :value="copyUrl" />
    </div>
</template>
<script>
import Statistics from "./components/statistics";
import { downloadFileTmp } from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: "",
    status: ""
}
export default {
    components: { Statistics },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",
                status: parseInt(this.$route.query.status) || "",
            },
            listLoading: true,
            sswap: process.env.VUE_APP_SSWAP_URL,
            copyUrl: "",
            copyTimer: null
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/scene/punch/pageList",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                        this.dataList.map(item => {
                            item.wapLink = `${this.sswap}/pages/special/checkIn/index?id=${item.id}`
                        })
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        add() {
            this.$router.push('/promotion/checkIn/add')
        },
        edit(id) {
            this.$router.push({
                path: `/promotion/checkIn/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        //复制链接
        copy(url) {
            clearTimeout(this.copyTimer);
            this.copyUrl = url;
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            }, 300)
        },
        //下载
        async download(id) {
            this.downLoading = true;
            let filePath;
            const res = await this.$request({
                url: '/scene/punch/downQrCode',
                method: 'post',
                params: {
                    id: id
                }
            })
                .catch(err => {
                    this.$message({ message: err.message, type: 'error' });
                })
            const { state, msg, result } = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            } else {
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }

            await downloadFileTmp(filePath, '现场打卡二维码.' + this.$utils.getFileType(filePath));
            this.downLoading = false;

        }
    }
}
</script>
<style lang="scss" scoped>
.copyTool {
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}
</style>